var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClipboardCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33268C14.1083 3.33268 14.4958 3.33268 14.8137 3.41787C15.6764 3.64904 16.3503 4.3229 16.5815 5.18563C16.6667 5.50355 16.6667 5.89104 16.6667 6.66602V14.3327C16.6667 15.7328 16.6667 16.4329 16.3942 16.9677C16.1545 17.4381 15.772 17.8205 15.3016 18.0602C14.7669 18.3327 14.0668 18.3327 12.6667 18.3327H7.33333C5.9332 18.3327 5.23314 18.3327 4.69836 18.0602C4.22795 17.8205 3.8455 17.4381 3.60582 16.9677C3.33333 16.4329 3.33333 15.7328 3.33333 14.3327V6.66602C3.33333 5.89104 3.33333 5.50355 3.41852 5.18563C3.64969 4.3229 4.32356 3.64904 5.18629 3.41787C5.5042 3.33268 5.89169 3.33268 6.66667 3.33268M7.5 12.4993L9.16667 14.166L12.9167 10.416M8 4.99935H12C12.4667 4.99935 12.7001 4.99935 12.8783 4.90852C13.0351 4.82863 13.1626 4.70114 13.2425 4.54434C13.3333 4.36608 13.3333 4.13273 13.3333 3.66602V2.99935C13.3333 2.53264 13.3333 2.29928 13.2425 2.12102C13.1626 1.96422 13.0351 1.83674 12.8783 1.75684C12.7001 1.66602 12.4667 1.66602 12 1.66602H8C7.53329 1.66602 7.29993 1.66602 7.12168 1.75684C6.96487 1.83674 6.83739 1.96422 6.7575 2.12102C6.66667 2.29928 6.66667 2.53264 6.66667 2.99935V3.66602C6.66667 4.13273 6.66667 4.36608 6.7575 4.54434C6.83739 4.70114 6.96487 4.82863 7.12168 4.90852C7.29993 4.99935 7.53329 4.99935 8 4.99935Z",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheck);
export default __webpack_public_path__ + "static/media/clipboard-check.4c051b1349ee939237128d15cdd53b1c.svg";
export { ForwardRef as ReactComponent };